var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowToUseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "How_to_Use_Icon",
    "data-name": "How to Use Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 32,
    height: 32,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.34 1.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M16.738,2A14.671,14.671,0,1,0,27.18,6.3,14.738,14.738,0,0,0,16.738,2Zm0,26.8A12.059,12.059,0,1,1,28.8,16.738,12.059,12.059,0,0,1,16.738,28.8Z",
    transform: "translate(-2 -2)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M12.7,2A10.654,10.654,0,1,0,20.286,5.12,10.7,10.7,0,0,0,12.7,2Z",
    transform: "translate(5.488 4.445)",
    fill: "#2666cf",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M23.34,36.7h-.268l-.268-.134h-.2l-.2-.2-.2-.2c0-.067-.067-.134-.134-.2s0-.2-.067-.268v-.536c.067-.067.067-.134.067-.268s.134-.134.134-.2l.2-.2a1.273,1.273,0,0,1,1.206-.4h.268l.2.134.2.2.2.2c0,.067.067.134.067.2a.508.508,0,0,0,.134.268v.536c-.067.067-.067.134-.134.268s-.067.134-.067.2l-.2.2-.2.2h-.2l-.268.134Z",
    transform: "translate(-8.602 -12.583)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M21.3,23.4h-.536a1.34,1.34,0,0,1-.737-1.742,4.89,4.89,0,0,1,2.412-2.613,3.283,3.283,0,0,0-.737-6.3,3.3,3.3,0,0,0-4.02,3.216,1.34,1.34,0,1,1-2.68,0,6.073,6.073,0,0,1,7.235-5.828,5.962,5.962,0,0,1,1.34,11.255A2.479,2.479,0,0,0,22.5,22.532,1.273,1.273,0,0,1,21.3,23.4Z",
    transform: "translate(-6.291 -4.644)",
    fill: "#2666cf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToUseIcon);
export default __webpack_public_path__ + "static/media/how-to-use-icon.7df1aea75333bd4a195ce42f66bc021a.svg";
export { ForwardRef as ReactComponent };